/* eslint-disable react/require-default-props */
/* eslint-disable indent */
/* eslint-disable camelcase */
import dynamic from 'next/dynamic';
import { Common } from '@stockbit/ui';
import ImageSlider from 'global/ImageSlider';
import Image from 'global/Image';
import { useSelector } from 'react-redux';
import { selectors } from 'lib/entities/credentials';
import { useMemo } from 'react';
import PollingContainer from '../PollingContainer';
import TargetPriceContainer from '../TargetPriceContainer';
import TextContent from '../TextContent';
import Comment from './Comment';
import DocumentContainer from './DocumentContainer';
import Header from './Header';
import PinnedLabel from './PinnedLabel';
import RepostBox from './RepostBox';
import RepostLabel from './RepostLabel';
import { ContentWrapper, StreamBoxContainer, TextContainer } from './styled';
import TitleContent from './TitleContent';
import { StreamPostData } from '../../../../@types/stream';
import YoutubePlayer from './YoutubePlayer';
import Footer from './Footer';
import { StreamEntryPoint } from '../types';

const { Flex, Text } = Common;

const GuestFooter = dynamic(() => import('./GuestFooter'), {
  ssr: false,
  loading: () => <div />,
});

const FollowingActivity = dynamic(() => import('./FollowingActivity'), {
  ssr: false,
  loading: () => <div />,
});

interface PostProps {
  post?: StreamPostData;
  onComment?: () => void;
  pinned?: boolean;
  showLatestComment?: boolean;
  hasFollowingActivity?: boolean;
  expandContent?: boolean;
  isFirstPost?: boolean;
  isSinglePost?: boolean;
  highlightWord?: string;
  entryPoint: StreamEntryPoint;
  symbol?: string;
  dataCyName?: string;
}

function Post({
  post,
  onComment,
  pinned = false,
  showLatestComment = true,
  hasFollowingActivity = true,
  expandContent = false,
  isFirstPost = false,
  isSinglePost = false,
  highlightWord = '',
  symbol = '',
  entryPoint,
  dataCyName,
}: PostProps) {
  const {
    content,
    content_original,
    images,
    attachment,
    polling,
    target_price,
    last_reply,
    mask_html,
    reposted,
    repostedfrom,
    title,
    titleurl,
    images_data,
    image_frame_type,
    following_activity: followingActivity,
    is_author: isAuthor,
  } = post;

  const { isLoggedIn } = useSelector(selectors);

  const imagesData = useMemo(() => {
    let listImage =
      images?.length > 0 && images[0] !== ''
        ? images.map((i) => ({ image: i }))
        : [];

    listImage = listImage.filter((i) => {
      const exist = images_data.find((img) => img.image === i.image);
      return !exist;
    });

    listImage = [...listImage, ...images_data];
    return listImage;
  }, [post]);

  const isHaveImage = Boolean(imagesData?.length > 0 && imagesData[0]?.image);
  const showFollowingActivity =
    followingActivity?.users?.length > 0 && hasFollowingActivity;
  const autoplayYoutube = !isSinglePost;

  return (
    <StreamBoxContainer data-cy={dataCyName}>
      {pinned && <PinnedLabel isCompanyPinnedPost={entryPoint === 'symbol'} />}
      {/* HIDE REPOST LABEL FOR A WHILE AFTER BE IMPROVE THE PERFORMANCE */}
      {/* {reposted > 0 && <RepostLabel username={repostedfrom.username} />} */}

      {showFollowingActivity && <FollowingActivity data={followingActivity} />}
      <Header
        post={post}
        isLoggedIn={isLoggedIn}
        entryPoint={entryPoint}
        symbol={symbol}
      />
      <ContentWrapper>
        {polling?.length && isLoggedIn > 0 ? (
          <PollingContainer
            post={post}
            isSinglePost={isSinglePost}
            isTextDefaultExpand={expandContent}
            highlightWord={highlightWord}
          />
        ) : (
          <>
            <TextContainer>
              {title && titleurl && (
                <TitleContent
                  title={title}
                  highlightWord={highlightWord}
                  titleUrl={titleurl}
                />
              )}
              <TextContent
                content={content}
                maskedHtml={mask_html}
                isDefaultExpand={expandContent}
                highlightWord={highlightWord}
              />
              {post.newsfeed_source && (
                <Flex>
                  <Image
                    alt={post.newsfeed_label}
                    src={post.newsfeed_img}
                    style={{ width: '16px', marginRight: '8px' }}
                  />
                  <Text size="12px">{post.newsfeed_label}</Text>
                </Flex>
              )}
            </TextContainer>

            {isHaveImage ? (
              <ImageSlider
                images={imagesData}
                frameType={image_frame_type}
                isSinglePost={isSinglePost}
              />
            ) : (
              <YoutubePlayer
                content={content_original}
                autoplay={autoplayYoutube}
              />
            )}

            {isLoggedIn ? (
              <>
                {attachment?.length > 0 && (
                  <DocumentContainer documents={attachment} />
                )}

                {target_price?.length > 0 && (
                  <TargetPriceContainer
                    targetPrice={target_price[0]}
                    postid={post.postid}
                    isAuthor={isAuthor}
                  />
                )}
              </>
            ) : null}
          </>
        )}

        {reposted > 0 && isLoggedIn && <RepostBox post={repostedfrom} />}

        {isLoggedIn ? (
          <Footer
            post={post}
            onComment={onComment}
            isFirstPost={isFirstPost}
            symbol={symbol}
          />
        ) : (
          <GuestFooter post={post} />
        )}
      </ContentWrapper>
      {isLoggedIn &&
        showLatestComment &&
        last_reply &&
        Object.keys(last_reply).length > 0 && (
          <Comment comment={last_reply} onClick={onComment} />
        )}
    </StreamBoxContainer>
  );
}

export default Post;
